function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }
function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
import * as $type from "../util/Type";
import * as $math from "../util/Math";
import * as $utils from "../util/Utils";
import { Rectangle } from "./Rectangle";
/**
 * Draws a rectangle with rounded corners.
 *
 * @see {@link https://www.amcharts.com/docs/v5/concepts/common-elements/graphics/} for more info
 * @important
 */
export var RoundedRectangle = /*#__PURE__*/function (_Rectangle) {
  _inherits(RoundedRectangle, _Rectangle);
  var _super = _createSuper(RoundedRectangle);
  function RoundedRectangle() {
    _classCallCheck(this, RoundedRectangle);
    return _super.apply(this, arguments);
  }
  _createClass(RoundedRectangle, [{
    key: "_beforeChanged",
    value: function _beforeChanged() {
      _get(_getPrototypeOf(RoundedRectangle.prototype), "_beforeChanged", this).call(this);
      if (this.isDirty("cornerRadiusTL") || this.isDirty("cornerRadiusTR") || this.isDirty("cornerRadiusBR") || this.isDirty("cornerRadiusBL")) {
        this._clear = true;
      }
    }
  }, {
    key: "_draw",
    value: function _draw() {
      var width = this.width();
      var height = this.height();
      var w = width;
      var h = height;
      var wSign = w / Math.abs(width);
      var hSign = h / Math.abs(height);
      if ($type.isNumber(w) && $type.isNumber(h)) {
        var minSide = Math.min(w, h) / 2;
        var crtl = $utils.relativeToValue(this.get("cornerRadiusTL", 8), minSide);
        var crtr = $utils.relativeToValue(this.get("cornerRadiusTR", 8), minSide);
        var crbr = $utils.relativeToValue(this.get("cornerRadiusBR", 8), minSide);
        var crbl = $utils.relativeToValue(this.get("cornerRadiusBL", 8), minSide);
        var maxcr = Math.min(Math.abs(w / 2), Math.abs(h / 2));
        crtl = $math.fitToRange(crtl, 0, maxcr);
        crtr = $math.fitToRange(crtr, 0, maxcr);
        crbr = $math.fitToRange(crbr, 0, maxcr);
        crbl = $math.fitToRange(crbl, 0, maxcr);
        var display = this._display;
        display.moveTo(crtl * wSign, 0);
        display.lineTo(w - crtr * wSign, 0);
        if (crtr > 0) {
          display.arcTo(w, 0, w, crtr * hSign, crtr);
        }
        display.lineTo(w, h - crbr * hSign);
        if (crbr > 0) {
          display.arcTo(w, h, w - crbr * wSign, h, crbr);
        }
        display.lineTo(crbl * wSign, h);
        if (crbl > 0) {
          display.arcTo(0, h, 0, h - crbl * hSign, crbl);
        }
        display.lineTo(0, crtl * hSign);
        if (crtl > 0) {
          display.arcTo(0, 0, crtl * wSign, 0, crtl);
        }
        display.closePath();
      }
    }
  }]);
  return RoundedRectangle;
}(Rectangle);
Object.defineProperty(RoundedRectangle, "className", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: "RoundedRectangle"
});
Object.defineProperty(RoundedRectangle, "classNames", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: Rectangle.classNames.concat([RoundedRectangle.className])
});